module.exports = __webpack_public_path__ + "static/img/fondo-loginstrategio.0e2a8f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fondo-loginstrategio.jpg
// module id = dkhU
// module chunks = 3